<template>
  <div class="point-viewer">
    <AppMapPointPanelHeader :header="header" @close="$emit('close')" />
    <div class="point-viewer__content">
      <AppMapPointPanelFirstRow @edit="edit" :id="point.id" img="/img/area-icon.png" :img-circle="false" :has-edit="can(PN.POINT_UPDATE)" />
      <table class="table user-view-table m-0">
        <tbody>
          <tr v-if="point.title">
            <th>Name:</th>
            <td>{{ point.title }}</td>
          </tr>
          <tr v-if="point.color">
            <th>Color:</th>
            <td><div class="point-viewer__color" :style="{'background-color': point.color}"></div></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as PN from '@/utils/PermissionNames'
import AppMapPointPanelHeader from '@/components/shared/AppMapPointPanelHeader.vue'
import { getItemHeader } from '@/components/shared/helpers'
import AppMapPointPanelFirstRow from '@/components/shared/AppMapPointPanelFirstRow.vue'

export default {
  name: 'AreaViewer',
  components: { AppMapPointPanelFirstRow, AppMapPointPanelHeader },
  data: () => ({
    PN,
    printerTemp: {}
  }),
  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },
  computed: {
    ...mapGetters('point', ['getPoint']),
    ...mapGetters('pointIcon', ['getPointIcon']),
    ...mapGetters('rbac', ['can']),
    header() {
      return getItemHeader(this.point, 'Area')
    },
    point() {
      return this.getPoint(this.id) || {}
    },
    pointIcon() {
      return this.getPointIcon(this.point.icon_id)
    }
  },
  methods: {
    edit() {
      this.$emit('edit')
    }
  }
}
</script>

<style>
.point-viewer__color {
  width: 100%;
  height: 24px;
}
.point-viewer__content {
  padding: 24px;
}
</style>
